import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchOptionGroup, deleteOptionGroup, editOptionGroup, clearOptionGroupsErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditOptionGroup from '../components/optiongroups/EditOptionGroup';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  optiongroup: PropTypes.object,
  optiongroups: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class OptionGroupEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      option: {
        name: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchOptionGroup(this.props.params.id));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.optiongroup && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Option group edited succesfully!',
        error: false,
      });
    }
  }
  deleteOptionGroup(ogId) {
    const optiongroups = this.props.optiongroups;
    optiongroups.delete = true;
    this.setState({ optiongroups });
    this.props.dispatch(deleteOptionGroup(ogId));
    browserHistory.push('/optiongroups?page=1');
  }
  saveEditOptionGroup(optiongroup) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editOptionGroup(optiongroup));
  }
  navigateToView(optiongroup) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editOptionGroup(optiongroup));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearOptionGroupsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/optiongroups/view/${this.props.optiongroup.id}`);
      } else {
        browserHistory.push('/optiongroups?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="optiongroup component" style={authPage}>
        <h2>Edit Option Group</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditOptionGroup
            optiongroup={this.props.optiongroup}
            onSave={data => this.saveEditOptionGroup(data)}
            onDelete={data => this.deleteOptionGroup(data)}
            onView={data => this.navigateToView(data)}
          />
        </div>
      </div>
    );
  }
}

OptionGroupEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionGroupEditPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    optiongroup: state.optiongroups.optiongroup,
    optiongroups: state.optiongroups,
    error: state.optiongroups.error,
  };
}

export default withRouter(connect(mapStateToProps)(OptionGroupEditPage));



// WEBPACK FOOTER //
// ./src/containers/OptionGroupEditPage.js